export type LoginFailureReason = 'cancelled' | 'expired' | 'google' | 'account' | 'unavailable';

export type LoginMessage = {
  title: string;
  description: string;
  actionLabel: string;
};

const defaultMessage: LoginMessage = {
  title: 'Heyday에 로그인',
  description: '회사 Google Workspace 계정으로 로그인해 주세요.',
  actionLabel: 'Google로 로그인',
};

const failureMessages: Record<LoginFailureReason, LoginMessage> = {
  cancelled: {
    title: 'Google 로그인이 취소되었습니다.',
    description: '계정 선택 또는 로그인 동의가 완료되지 않았습니다. 다시 시도해 주세요.',
    actionLabel: 'Google로 다시 로그인',
  },
  expired: {
    title: '로그인 연결이 만료되었습니다.',
    description: '로그인 창을 오래 열어두었거나 여러 창에서 로그인을 시도해 이전 연결을 사용할 수 없습니다.',
    actionLabel: 'Google로 다시 로그인',
  },
  google: {
    title: 'Google 로그인을 완료하지 못했습니다.',
    description: '일시적인 Google 로그인 오류입니다. 잠시 후 다시 시도해 주세요.',
    actionLabel: 'Google로 다시 로그인',
  },
  account: {
    title: '이 계정으로 로그인할 수 없습니다.',
    description: 'Heyday에 등록된 재직자 Google Workspace 계정인지 확인해 주세요. 계속되면 관리자에게 문의해 주세요.',
    actionLabel: '다른 Google 계정으로 로그인',
  },
  unavailable: {
    title: '로그인 서비스를 잠시 사용할 수 없습니다.',
    description: '일시적인 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    actionLabel: 'Google로 다시 로그인',
  },
};

export function parseLoginFailureReason(search: string): LoginFailureReason | undefined {
  const reason = new URLSearchParams(search).get('reason');
  if (reason && Object.hasOwn(failureMessages, reason)) return reason as LoginFailureReason;
  return undefined;
}

export function loginMessage(reason?: LoginFailureReason): LoginMessage {
  return reason ? failureMessages[reason] : defaultMessage;
}

export function recoveryLoginPath() {
  return `/api/auth/login?${new URLSearchParams({ returnTo: '/', selectAccount: '1' })}`;
}
